import { createContext, useContext, type ReactNode } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from './api.ts';
import { REGLAGES_SALARIES_DEFAUT, type ReglagesSalaries } from '@shared/salaries.ts';

export interface Moi {
  utilisateur: { id: string; nom: string; email: string; changerMotDePasse: boolean; mfa: boolean; mfaAActiver: boolean;
    /** Téléphone professionnel (null = non renseigné). */
    telephonePro?: string | null };
  organisation: { id: string; nom: string;
    /** Confidentialité des salariés (réglages de la société) ; état de l'engagement pour l'administrateur seulement. */
    salaries?: ReglagesSalaries & { engagement: { etat: 'absent' | 'demo' | 'a_renouveler' | 'a_jour'; le: string | null } | null } };
  roles: { code: string; libelle: string }[];
  permissions: string[];
}

export interface EtatServices {
  ia: { fournisseur: string; disponible: boolean; local: boolean; documentsClientsAutorises: boolean; modele: string | null; raison?: string };
  stockage: string; base: string; coffre: boolean; production: boolean;
}

const Contexte = createContext<{ moi: Moi; etat: EtatServices | undefined; peut: (p: string) => boolean } | null>(null);

export function useSessionRequete() {
  return useQuery({ queryKey: ['moi'], queryFn: () => api.get<Moi>('/api/auth/moi'), retry: false, staleTime: 60_000 });
}

export function FournisseurSession({ moi, children }: { moi: Moi; children: ReactNode }) {
  const etat = useQuery({ queryKey: ['etat'], queryFn: () => api.get<EtatServices>('/api/etat'), staleTime: 300_000 });
  const peut = (p: string) => moi.permissions.includes(p);
  return <Contexte.Provider value={{ moi, etat: etat.data, peut }}>{children}</Contexte.Provider>;
}

export function useSession() {
  const c = useContext(Contexte);
  if (!c) throw new Error('useSession hors session');
  return c;
}

/** Réglages de confidentialité des salariés de la société : l'écran masque (photos, temps) ; le serveur, lui, refuse. */
export function useReglagesSalaries(): ReglagesSalaries {
  const { moi } = useSession();
  const r = moi.organisation.salaries;
  return r ? { nom: r.nom, telephoneCoequipiers: r.telephoneCoequipiers, photos: r.photos, temps: r.temps } : REGLAGES_SALARIES_DEFAUT;
}
